import React from 'react';
import {useDispatch} from 'react-redux';
import moment from 'moment/moment';
import {DownloadFile, formatAMPM, previewFile, Images, useModal} from 'utils';
import {CustomDelete, MinLoader, TextRow} from 'components';
import {appointmentActions} from 'store';
import {signatureTypeEnums} from '../constants';
import {scheduleStatuses} from '../../../constants';

const DELETE_ACTION_TYPE = 'DELETE_SIGNATURE';
export const SignatureDetails = ({item}) => {
    const {loadDownload, handleDownload, currentId} = DownloadFile();
    const {open} = useModal();
    const dispatch = useDispatch();
    const signorName = item?.signorFullName;

    const handleRemove = (signature, type) => {
        open(
            <CustomDelete
                text={`Are you sure you want to delete this signature?`}
                info={`Delete ${type === signatureTypeEnums.SIGNATURE ? 'Client' : 'Provider'} Signature?`}
                handleDel={() => dispatch(appointmentActions.deleteSignature(item?.id, type))}
                handleClose={() => close()}
                actionType={DELETE_ACTION_TYPE}
                body={
                    <div className="deleting-client-info-box">
                        <img src={Images.signatureRemove} alt={'credential'}/>
                        <p>{signature?.originalName}</p>
                    </div>
                }
            />
        );
    };

    return (
        <>
            <div className="signature-process">
                {item?.providerSignature?.key && (
                    <div className="flex-align-center" style={{gap: 8}}>
                        <p className="signature-title">Provider sign:</p>
                        <div className="flex-align-center full-width" style={{gap: 8}}>
                            <div className="flex-align-center" style={{gap: 8, width: '33%'}}>
                                <div className="signature-detail-box" style={{maxWidth: '100%'}}>
                                    <div className="flex-align-center" style={{gap: 4}}>
                                        <img src={Images.signatureFile} alt="icon"/>
                                        <p className="signature-detail-name">
                                            <TextRow name={item?.providerSignature?.originalName} textWidth={8}/>
                                        </p>
                                    </div>
                                </div>
                                <div className="flex-align-center" style={{gap: 8}}>
                                    <button onClick={() => previewFile(item?.providerSignature)}
                                            className="square-btn-box">
                                        <img height={20} src={Images.showEye} alt="icon"/>
                                    </button>
                                    <button
                                        onClick={() => handleDownload(item?.providerSignature, item?.providerSignature?.key)}
                                        className="square-btn-box"
                                    >
                                        {loadDownload && currentId === item?.providerSignature?.key ? (
                                            <MinLoader small={true} color={'#475467'} margin={'0'}
                                                       position={'relative'}/>
                                        ) : (
                                            <img height={20} src={Images.downloadCloud} alt="icon"/>
                                        )}
                                    </button>
                                    {item?.status === scheduleStatuses.PENDING && (
                                        <button
                                            onClick={() => handleRemove(item?.signature, signatureTypeEnums.PROVIDER_SIGNATURE)}
                                            className="square-btn-box"
                                        >
                                            <img height={20} src={Images.redTrash} alt="icon"/>
                                        </button>
                                    )}
                                </div>
                            </div>

                            <div className="signature-detail-box" style={{maxWidth: '33%'}}>
                                <div className="flex-align-center" style={{gap: 4}}>
                                    <img src={Images.signatureDate} alt="icon"/>
                                </div>
                                <p className="signature-detail-box-value">
                                    {`${moment(item?.providerSignatureDate).local().format('MM/DD/YYYY, h:mm A')}`}
                                    {/*{`${moment.utc(item?.providerSignatureDate).format('MM/DD/YYYY')}, ${formatAMPM(item?.providerSignatureDate)}`}*/}

                                    {/*// ${moment(item?.providerSignatureDate).format('h:mm a')}*/}
                                </p>
                            </div>

                            <div className="signature-detail-box" style={{width: '33%'}}>
                                <div className="flex-align-center" style={{gap: 4}}>
                                    <img src={Images.signatureLocation} alt="icon"/>
                                </div>
                                <p className="signature-detail-box-value full-width">
                                    <TextRow
                                        name={
                                            item?.providerSignatureLocation?.formattedAddress
                                                ? item?.providerSignatureLocation?.formattedAddress
                                                : 'Not Set'
                                        }
                                    />
                                </p>
                            </div>
                        </div>
                    </div>
                )}

                {item?.signature?.key && item?.providerSignature?.key && <div className="signature-border-line"/>}

                {item?.signature?.key && (
                    <div className="flex-align-center" style={{gap: 8}}>
                        <p className="signature-title">Client sign:</p>
                        <div className="flex-align-center full-width" style={{gap: 8}}>
                            <div className="flex-align-center" style={{gap: 8, width: '33%'}}>
                                <div className="signature-detail-box" style={{maxWidth: '100%'}}>
                                    <div className="flex-align-center" style={{gap: 4}}>
                                        <img src={Images.signatureFile} alt="icon"/>
                                        <p className="signature-detail-name">
                                            <TextRow name={item?.signature?.originalName} textWidth={8}/>
                                        </p>
                                    </div>
                                </div>
                                <div className="flex-align-center" style={{gap: 8}}>
                                    <button onClick={() => previewFile(item?.signature)} className="square-btn-box">
                                        <img height={20} src={Images.showEye} alt="icon"/>
                                    </button>
                                    <button
                                        onClick={() => handleDownload(item?.signature, item?.signature?.key)}
                                        className="square-btn-box"
                                    >
                                        {loadDownload && currentId === item?.signature?.key ? (
                                            <MinLoader small={true} color={'#475467'} margin={'0'}
                                                       position={'relative'}/>
                                        ) : (
                                            <img height={20} src={Images.downloadCloud} alt="icon"/>
                                        )}
                                    </button>

                                    {item?.status === scheduleStatuses.PENDING && (
                                        <button
                                            onClick={() => handleRemove(item?.signature, signatureTypeEnums.SIGNATURE)}
                                            className="square-btn-box"
                                        >
                                            <img height={20} src={Images.redTrash} alt="icon"/>
                                        </button>
                                    )}
                                </div>
                            </div>

                            <div className="signature-detail-box" style={{maxWidth: '33%'}}>
                                <div className="flex-align-center" style={{gap: 4}}>
                                    <img src={Images.signatureDate} alt="icon"/>
                                </div>
                                <p className="signature-detail-box-value flex-align-center full-width" style={{gap: 8}}>
                                    <span>{`${moment(item?.signatureDate).local().format('MM/DD/YYYY, h:mm A')}`}</span>
                                    {signorName && (
                                        <span className='full-width'>
                                           <TextRow name={`Signed by: ${signorName}`}/>
                                        </span>
                                    )}
                                </p>
                            </div>

                            <div className="signature-detail-box" style={{width: '33%'}}>
                                <div className="flex-align-center" style={{gap: 4}}>
                                    <img src={Images.signatureLocation} alt="icon"/>
                                </div>
                                <p className="signature-detail-box-value full-width">
                                    <TextRow
                                        name={
                                            item?.signatureLocation?.formattedAddress
                                                ? item?.signatureLocation?.formattedAddress
                                                : 'Not Set'
                                        }
                                    />
                                </p>
                            </div>
                        </div>
                    </div>
                )}
            </div>
        </>
    );
};
